// src/components/ViewpointFlow.js
import React, { useState } from "react";
import ViewpointForm from "./ViewpointForm";
import CameraConfig from "./CameraConfig";

const ViewpointFlow = ({ initialData = {}, onComplete, existingCameraCount = 0 }) => {
  const [step, setStep] = useState(1);
  // Ensure initialData might contain gpsCoordinatesString if editing
  const [viewpointData, setViewpointData] = useState(initialData);

  const handleNext = (data) => {
    console.log('step:', step);
    if (data === null) {
      // User clicked back from ViewpointForm
      onComplete(); // Or handle going back appropriately
    } else if (step === 1) {
      // Data from ViewpointForm (includes gpsCoordinatesString now)
      setViewpointData((prev) => ({ ...prev, ...data }));

      // Existing logic to determine next step or completion
      if (data.pointType === 'relay_point') {
        if (data.hasCameras === 'yes') {
          console.log('Relay point with cameras - Intermediate data:', { ...viewpointData, ...data });
          setStep(2);
        } else {
          const finalData = { ...viewpointData, ...data, cameras: [] };
          console.log('Relay point without cameras - Final data:', finalData);
          onComplete(finalData); // Pass combined data
        }
      } else if (data.pointType === 'vision_point') {
        console.log('Vision point - Intermediate data:', { ...viewpointData, ...data });
        setStep(2);
      } else if (data.pointType === 'high_point') {
        const finalData = { ...viewpointData, ...data, cameras: [] };
        console.log('High point - Final data:', finalData);
        onComplete(finalData); // Pass combined data
      } else if (data.pointType === 'surveillance_center') {
        const finalData = { ...viewpointData, ...data, cameras: [] };
        console.log('Surveillance center - Final data:', finalData);
        onComplete(finalData); // Pass combined data
      }
    } else if (step === 2) {
      // Data from CameraConfig
      // viewpointData already contains gpsCoordinatesString from step 1
      const finalData = { ...viewpointData, cameras: data };
      onComplete(finalData); // Pass final combined data
    }
  };

  return (
    <>
      {step === 1 && (
        <ViewpointForm onNext={handleNext} initialData={viewpointData} existingCameraCount={existingCameraCount} />
      )}
      {step === 2 && (
        <div style={{marginBottom:"100px"}}>
        <CameraConfig
          onSave={handleNext}
          initialCameras={viewpointData.cameras || []}
          // Pass location if needed for CameraConfig back button or state
          // location={location} // Assuming location prop is available if needed
        />
        </div>
      )}
    </>
  );
};

export default ViewpointFlow;
